'use strict';

module.exports = ['$translate', function ($translate) {
    return function (groupList, callback) {
        callback = callback || function (group) {
            return group.title;
        };
        var selected = [];
        angular.forEach(groupList, function (group) {
            selected.push(callback(group));
        });
        return (groupList && groupList.length > 0) ? selected.join(", ") :
                $translate.instant('jdro_common.not_set_more');
    };
}];



//////////////////
// WEBPACK FOOTER
// ./src/modules/ngDro-uaa/filters/GroupListHelper.js
// module id = 404
// module chunks = 0